module.exports = __webpack_public_path__ + "static/media/imprimir_conta.e8700503.svg";